import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { CommonMethod } from 'src/app-core/method/common-method';
import { CommonService } from 'src/app-core/services/common.service';
import { CustomToastrService } from 'src/app-core/services/custom-toastr-service';

@Component({
  selector: 'app-parse-shipment-data',
  templateUrl: './parse-shipment-data.component.html',
  styleUrls: ['./parse-shipment-data.component.scss']
})
export class ParseShipmentDataComponent implements OnInit {
  emailText: string;
  isFormLoading: boolean = false;
  constructor(private customToastrService: CustomToastrService, private commonMethod: CommonMethod, private dialogRef: MatDialogRef<ParseShipmentDataComponent>, private commonService: CommonService) { }

  ngOnInit() { }

  onClose() {
    this.emailText = '';
    this.commonService.getLLMShipmentErrorMsg('');
    this.dialogRef.close();
  }

  onSubmit() {
    this.isFormLoading = true;
    this.commonService.getShipmentJSONData(null)
    this.commonService.resetOpenAIdataMethod(true);
    setTimeout(() => {
      const payload = {
        requestContent: this.emailText
      }

      this.commonService.getSmartShipmentByLLM(payload).subscribe((data: any) => {
        if (data) {
          data.OriginAddress.ShippingStartTime = this.commonMethod.getPickUpFromDate(data, data.hasOwnProperty('PickupDate') ? data.PickupDate : '');
          data.OriginAddress.ShippingEndTime = this.commonMethod.getPickUpToDate(data, data.hasOwnProperty('PickupDate') ? data.PickupDate : '')
          data.OriginAddress.PickupDate = this.commonMethod.getPickUpDate(data, data.hasOwnProperty('PickupDate') ? data.PickupDate : '')
          this.commonService.resetOpenAIdataMethod(false);
          const shipmentData = this.commonMethod.formatShipmentData(data);
          this.commonService.getShipmentJSONData(shipmentData);
        }

        this.isFormLoading = false;
        this.dialogRef.close();
      }, error => {
        this.isFormLoading = false;
        const message = 'Error encountered while processing shipment information.';
        this.customToastrService.errorToastr(message);
        this.commonService.resetOpenAIdataMethod(true);
        this.onClose();
      })
    }, 2000);
  }

  getValue(value: any, defaultValue: any = null) {
    return value !== undefined ? value : defaultValue;
  }

  getArray(value: any) {
    return Array.isArray(value) ? value : [];
  }

}
